import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import WebsitePreview from "../WebsitePreview/WebsitePreview"

export default function Web() {
    return (
        <Container>
            <Box>
                <h1>Web Development</h1>
                <p>
                    I've been interested in coding from a young age, spending much of my time editing code in Notepad on my PC.
                    I later attended a Web Development Bootcamp, where I learned the MERN stack.
                </p>
                <p>
                    This single-page application (SPA) was built using React and JavaScript, with most components styled using the
                    <strong> styled-components</strong> library.
                </p>
                <br></br>
                <p><h1>Recent projects:</h1></p>

                <Project>
                    <Link to="https://4nbawordle.netlify.app/">NBA Wordle</Link>: A React project based on the game Wordle.
                    <WebsitePreview url="https://4nbawordle.netlify.app/" />
                </Project>

                <Project>
                    <Link to="https://glowing-puffpuff-707242.netlify.app/">Cat Facts</Link>: A React + TypeScript + Tailwind project that utilizes the Cat Fact API.
                    <WebsitePreview url="https://glowing-puffpuff-707242.netlify.app/" />
                </Project>

                <Project>
                    <Link to="https://vincecatfacts.netlify.app/">Cat CRUD</Link>: Created with Vite + React. This site utilizes a backend created with Node.js and Express.
                    <WebsitePreview url="https://vincecatfacts.netlify.app/" />
                </Project>
            </Box>
        </Container>
    )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 80px; /* pushes content below the navbar */

  @media only screen and (min-width: 600px) {
    margin-left: 20%;
    margin-right: 20%;
  }
`

const Box = styled.div`
  width: 100%;
  max-width: 700px;
  line-height: 1.6;
`

const Project = styled.div`
  margin-bottom: 40px;
`
